import ReactDOM from 'react-dom/client';
import './index.css';
import MainPage from './app/pages/main/main';
import { ThemeProvider } from "./app/context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <MainPage />
  </ThemeProvider>
);
